import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';

// Tabs
import ScheduleMainTab from './Elements/ScheduleMainTab';
import ScheduleGradeAircraftsTab from './Elements/ScheduleGradeAircraftsTab';
import ScheduleGradeOffScheduleTab from './Elements/ScheduleGradeOffScheduleTab';
import ScheduleGradeVacationTab from './Elements/ScheduleGradeVacationTab';
import ScheduleGradeVacationLimitTab from './Elements/ScheduleGradeVacationLimitTab';
import ScheduleGradeCommentsTab from './Elements/ScheduleGradeCommentsTab';
import BasesYearsTab from '../Bases/Elements/BasesYearsTab';

class ScheduleGradesEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      base_year: {},
      schedule_grade: {},
      schedule: {},
      base: {},
      alerts: {},
      schedule_grade_aircrafts: {},
      schedule_grade_staffs: {},
      enrolled_staffs: {},
      unavailable_staff_ids: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.viewAlerts = this.viewAlerts.bind(this);
    this.closeModalAlert = this.closeModalAlert.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var base_id = 0;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/info/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/escalas');
        base_id = responseJson.data.main.schedule.base.id;
        if (responseJson.status === 'success') {
          self.setState({regimes_by_id: responseJson.data.regimes_by_id});
          self.setState({schedule_grade: responseJson.data.main});
          self.setState({base_year: responseJson.data.base_year});
          self.setState({unavailable_staff_ids: responseJson.data.unavailable_staff_ids});
          self.setState({schedule: responseJson.data.main.schedule});
          self.setState({base: responseJson.data.main.schedule.base});
          self.setState({aircrafts: responseJson.data.aircrafts});
          self.setState({schedule_grade_groups: responseJson.data.schedule_grade_groups});
          self.setState({schedule_grade_staffs: responseJson.data.schedule_grade_staffs});
          self.setState({schedule_grade_aircrafts: responseJson.data.schedule_grade_aircrafts});
          self.setState({vacations: responseJson.data.vacations});
          self.setState({vacations_schedules: responseJson.data.vacations_schedules});
          self.setState({schedule_grade_comments: responseJson.data.schedule_grade_comments});
          self.setState({staffs_index: responseJson.data.staffs_index});
          self.setState({staffs_planning: responseJson.data.staffs_planning});
          self.setState({aircraft_models: responseJson.data.aircraft_models});
          self.setState({aircraft_model_subtypes: responseJson.data.aircraft_model_subtypes});
          self.setState({staffs: responseJson.data.staffs});
          self.setState({staffs_available: responseJson.data.staffs_available});
          self.setState({groups: responseJson.data.groups});
          self.setState({roles: responseJson.data.roles});
          self.setState({periods: responseJson.data.periods});
          self.setState({groups_select: responseJson.data.groups_select});
          self.setState({regimes_select: responseJson.data.regimes_select});
          self.setState({open_schedule_grades: responseJson.data.open_schedule_grades});
          self.setState({open_schedule_grade_groups: responseJson.data.open_schedule_grade_groups});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  // Fecha modal
  closeModalAlert(event){
    this.setState({modal_alert: false, alerts: {}});
  }


  // gero os dados do modal de alertas da grade
  viewAlerts (schedule_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alertas/' + schedule_id + '/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_alert: true});
      })
    });
  }

  updateData (responseJson) {
    this.setState({updated: 1}, this.loadData(responseJson));
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={self.handleLoaded} />
  <Overlay overlay={self.state.overlay} handleAlert={self.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Edição de escala - {self.state.base.name} - {self.state.schedule.name}</h3>
      <Link to={"/escala/editar/" + self.state.schedule.id} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="btn-group button-inline pull-right">
        <button onClick={() => { self.viewAlerts(self.state.schedule.id) }} className="btn btn-warning"><i className="fa fa-warning"></i> Exibir alertas</button>
      </div>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={self.state.key} onSelect={self.handleNavTab.bind(self, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Escala">
          <ScheduleMainTab schedule_grade_id={self.props.match.params.id} schedule={self.state.schedule} schedule_id={self.state.schedule.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} schedule_grade_staffs={self.state.schedule_grade_staffs} schedule_grade_groups={self.state.schedule_grade_groups} staffs={self.state.staffs} roles={self.state.roles} groups={self.state.groups} periods={self.state.periods} aircraft_models={self.state.aircraft_models} aircraft_model_subtypes={self.state.aircraft_model_subtypes} open_schedule_grade_groups={self.state.open_schedule_grade_groups} groups_select={self.state.groups_select} regimes_select={self.state.regimes_select} />
        </Tab>
        <Tab eventKey={2} title="Aeronaves">
          <ScheduleGradeAircraftsTab base={self.state.base} schedule={self.state.schedule} schedule_grade={self.state.schedule_grade} schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} aircrafts={self.state.aircrafts} schedule_grade_aircrafts={self.state.schedule_grade_aircrafts} open_schedule_grades={self.state.open_schedule_grades} />
        </Tab>
        <Tab eventKey={3} title="Colaboradores não escalados">
          <ScheduleGradeOffScheduleTab schedule_grade_id={self.props.match.params.id} schedule={self.state.schedule} schedule_id={self.state.schedule.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} staffs_available={self.state.staffs_available} />
        </Tab>
        <Tab eventKey={4} title="Férias">
          <ScheduleGradeVacationTab schedule_grade_id={self.props.match.params.id} schedule={self.state.schedule} schedule_id={self.state.schedule.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} vacations_schedules={self.state.vacations_schedules} staffs_planning={self.state.staffs_planning}  vacations={self.state.vacations} unavailable_staff_ids={self.state.unavailable_staff_ids} staffs={self.state.staffs} />
        </Tab>
        <Tab eventKey={5} title="Férias a vencer">
          <ScheduleGradeVacationLimitTab schedule_grade_id={self.props.match.params.id} schedule={self.state.schedule} schedule_id={self.state.schedule.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} staffs_index={self.state.staffs_index} />
        </Tab>
        <Tab eventKey={6} title="Comentários">
          <ScheduleGradeCommentsTab schedule_grade_id={self.props.match.params.id} status={self.state.schedule_grade.status} schedule={self.state.schedule} schedule_id={self.state.schedule.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} schedule_grade_comments={this.state.schedule_grade_comments} regimes_select={self.state.regimes_select} regimes_by_id={self.state.regimes_by_id} />
        </Tab>
        <Tab eventKey={7} title="Períodos da base">
          <BasesYearsTab updateData={self.updateData} updated={self.updated} handleAlert={self.handleAlert} loadData={self.loadData} base_year={self.state.base_year} base_year_id={self.state.base_year.id} base_year_periods={self.state.base_year.base_year_periods} base_year_period_lists={[]} />
        </Tab>
      </Tabs>
    </div>
  </div>
  <Modal show={self.state.modal_alert} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Revisão {self.state.schedule_grade.revision} - {self.state.base.name} - {self.state.schedule.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.base_alerts !== 'undefined') ?
      <div>
        <h4><strong>Mínimos por designação</strong></h4>
        {Object.keys(self.state.alerts.base_alerts).map(function(k) {
          var alert = self.state.alerts.base_alerts[k];
          if (alert.status === 'danger') {
            return(
              <div className={"box-alert box-alert-" + alert.color}>
                  <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
              </div>
            );
          } else {
            return(
              ''
            );
          }
        })}
        <hr/>
      </div>
      :
      ''
    }
    {
      (typeof self.state.alerts.staff_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.staff_alerts).map(function(nickname) {
          var alerts = self.state.alerts.staff_alerts[nickname];
          return(
            <div>
              <h4><strong>{nickname}</strong></h4>
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'error') {
                  return(
                    <div className={"box-alert box-alert-" + alert.color}>
                        <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                    </div>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
              <hr/>
            </div>
          );
        })}
      </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ScheduleGradesEdit;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/ScheduleGradesEdit.js